import { alias, primitive, serializable } from 'serializr';
import { RcFile } from 'antd/lib/upload';

export class LiveStockCommodityModel {
  @serializable
  id?: number;

  @serializable
  name?: string;

  @serializable
  image?: RcFile;

  @serializable(alias('category_id', primitive()))
  categoryId?: number;

  @serializable(alias('location_id', primitive()))
  locationId?: string;

  @serializable(alias('total_weight_of_milk_produced', primitive()))
  totalWeightOfMilkProduced?: number;

  @serializable
  year?: number;

  @serializable(alias('protien_percentage', primitive()))
  protienPercentage?: number;

  @serializable(alias('fat_percentage', primitive()))
  fatPercentage?: number;

  @serializable(alias('total_weight_of_eggs', primitive()))
  totalWeightOfEggs?: number;

  @serializable(alias('revenue_percentage', primitive()))
  revenuePercentage?: number;

  @serializable(alias('image_url', primitive()))
  imageUrl?: string;

  @serializable(alias('livestock_category', primitive()))
  livestockCategory?: string;

}
